import src from "IMAGE";
export default { src, width: 1900, height: 1900, blurWidth: 0, blurHeight: 0};
